var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoval(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.115 1.584 14.106 1 3.486 6.097V7.69l8.39 4.832v1.766l-8.76-4.952L2 10.133l.425 11.363 1.274 1.008 7.38-4.513.796.426v.903l-7.009 4.406v1.115L13.841 31l1.275-.743.372-9.77.796-.531.797.53.371 9.77 1.276.744 8.973-6.16v-1.114l-7.01-4.407v-.904l.797-.425 7.38 4.514 1.275-1.008.424-11.363-1.115-.797-8.76 4.952v-1.766l8.39-4.832V6.097L18.46 1l-1.009.584v8.814l-1.167.797-1.168-.797V1.584zM17.77 15.94v-1.453l-1.487.902-1.487-.903v1.452l.531.299v.955l.956-.425.956.425v-.956l.53-.301zM11.982 8.75 8.478 7l3.504-1.858v3.61zm-6.796 5.682 3.186 1.964-3.186 1.593v-3.556zm4.3 9.982 2.496 1.327v-3.026l-2.495 1.699zm17.895-9.982-3.185 1.964 3.186 1.593v-3.556zm-4.3 9.982-2.496 1.327v-3.026l2.496 1.699zM24.088 7l-3.504 1.752v-3.61L24.088 7z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoval);
export default __webpack_public_path__ + "static/media/COVAL.68f96153932a90adb42966e14bbe7cfa.svg";
export { ForwardRef as ReactComponent };